"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const merchant_1 = require("./merchant");
const interface_1 = require("./payload/interface");
const qr_1 = __importDefault(require("./qr"));
//dependencies
const mxw_libs_errors_1 = require("mxw-libs-errors");
class MXWRegister extends merchant_1.Merchant {
    constructor(id, uri, path) {
        super(uri, path);
        this.id = id;
    }
    init() {
        if (null == this.id || undefined == this.id || "" == this.id.trim()) {
            throw mxw_libs_errors_1.createError(mxw_libs_errors_1.errors.INVALID_PARAMETER, "Invalid ID");
        }
        try {
            this.socket = this.connection();
        }
        catch (error) {
            throw error;
        }
        finally {
            if (this.socket) {
                this.socket.open();
                // common socket events
                this.socket.on('connect_error', (error) => {
                    this.onError(mxw_libs_errors_1.createError("Socket Connection Error", error));
                });
                this.socket.on("disconnect", (reason) => {
                    if ("io client disconnect" == reason) {
                        console.log("Client has manually disconnected");
                    }
                    else {
                        this.onError(mxw_libs_errors_1.createError("Socket Disconnected", reason));
                    }
                });
                // get authorization first
                this.socket.emit("authorize", JSON.stringify({
                    ac: '',
                    id: this.id,
                }));
                // custom socket events
                this.socket.on("welcome", (data) => {
                    this.channel = data;
                    this.connected = true;
                    this.onConnect(true);
                    this.socket.on(this.channel, (data) => {
                        try {
                            this.onEvent(data);
                        }
                        catch (error) {
                            this.onError(error);
                        }
                    });
                });
            }
        }
    }
    // events
    onEvent(message) {
        let payload;
        let action;
        try {
            payload = interface_1.checkPayload(JSON.parse(message));
        }
        catch (error) {
            throw mxw_libs_errors_1.createError(mxw_libs_errors_1.errors.INVALID_PARAMETER, "Invalid payload", { error });
        }
        action = payload.payload.type;
        switch (action) {
            case 'SC':
                return this.onScan(payload);
            case 'SO':
                return this.onSignOn(payload);
            case 'SU':
                return this.onSignUp(payload);
            case 'SOER':
            case 'SUER':
                throw mxw_libs_errors_1.createError(mxw_libs_errors_1.errors.INVALID_PARAMETER, payload.payload.data.msg);
            default:
                throw mxw_libs_errors_1.createError(mxw_libs_errors_1.errors.INVALID_PARAMETER, "Invalid event");
        }
    }
    onError(data) {
        return data;
    }
    onConnect(data) {
        return data;
    }
    onScan(data) {
        return data;
    }
    onSignOn(data) {
        return data;
    }
    onSignUp(data) {
        return data;
    }
    signOn(includeChannel = true) {
        try {
            let qr = new qr_1.default(this.id, (!includeChannel ? null : this.channel));
            return qr.signOn();
        }
        catch (error) {
            throw error;
        }
    }
    signUp(pk, includeChannel = true) {
        try {
            let qr = new qr_1.default(this.id, (!includeChannel ? null : this.channel));
            return qr.signUp(pk);
        }
        catch (error) {
            throw error;
        }
    }
    disconnect() {
        this.socket.disconnect();
    }
    isConnected() {
        return this.connected;
    }
}
exports.default = MXWRegister;
//# sourceMappingURL=mxw-register.js.map